import React, { useMemo } from "react";
import { Button } from "@shared/ui/components/shadcn/button";
import { cn } from "@shared/ui/utils/tailwind";

interface BaseSocialButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  children?: React.ReactNode;
  loading?: boolean;
  variant: "google" | "facebook" | "apple";
  icon: React.ReactNode;
}

const BaseSocialButton: React.FC<BaseSocialButtonProps> = React.memo(({
  onClick,
  disabled = false,
  className = "",
  children,
  loading = false,
  icon,
}) => {
  const buttonClass = useMemo(
    () => cn(
      "w-full h-11 flex items-center justify-center gap-2.5 text-sm font-normal tracking-wide transition-all duration-200",
      loading && "opacity-60",
      className
    ),
    [loading, className]
  );

  return (
    <Button
      type="button"
      variant="outline"
      className={buttonClass}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {icon}
      {children}
    </Button>
  );
});

BaseSocialButton.displayName = "BaseSocialButton";

export default BaseSocialButton;
